<template>
  <div v-if="show">
    <McAlert class="bell-notification-wrapper w-100 my-3" variant="warning">
      <template slot="label">
        <div class="d-flex w-100">
          <div class="me-2">
            <BellNotificationIcon />
          </div>
          <div class="flex-grow-1">
            <p class="mb-0" style="font-size: 16px">{{ $t('master.form.address.freeWhatsappTitle') }}</p>
            <p class="mb-0" style="font-size: 13px; font-weight: 400;" v-html="$t('fleetTaskInstant.form.address.freeWhatsappCaption', { 'link': 'https://wa.me/6281112517966?text=Aktifkan%20Notifikasi'})" />
          </div>
          <div>
            <i class="mc-fa icon-outline_close close-icon" style="cursor: pointer;" @click="hide"></i>
          </div>
        </div>
      </template>
    </McAlert>
  </div>
</template>

<script>
import McAlert from '@/components/McAlert'
import BellNotificationIcon from './BellNotificationIcon';

export default {
  components: {
    McAlert,
    BellNotificationIcon,
  },
  props: {
    classes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    hide() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.close-icon::before {
  color: #99A1B1
}

:deep(a) {
  color: $mep-primary;
}
</style>